<!-- 自定义内容的下拉列表 -->
<template>
  <a-select :getPopupContainer = "getPopupContainer" :placeholder="placeholder" :disabled="disabled" :value="getValueSting" @change="handleInput">
    <a-select-option :value="undefined">请选择</a-select-option>
    <a-select-option v-for="(item, key) in dictOptions" :key="key" :value="item.value">
      <span style="display: inline-block;width: 100%" :title=" item.text || item.label ">
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>

  export default {
    name: "JDictSelectTagZdy",
    props: {
      defaultValue: {
        type: String,
        default: '',
        required: false
      },
      placeholder: String,
      triggerChange: Boolean,
      disabled: Boolean,
      value: [String, Number],
      type: String,
      dictOptions:Array,
      getPopupContainer:{
        type: Function,
        
        default: (node) => node.parentNode
      }
    },
    data() {
      return {
        tagType:""
      }
    },
    created() {
      // console.log(this.dictCode);
      //获取字典数据
      // this.initDictData();
    },
    computed: {
      getValueSting(){
        // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
        // 当有null或“” placeholder不显示
        return this.value != null ? this.value.toString() : undefined;
        // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      },
    },
    methods: {
      handleInput(e) {
        let val;
        val = e
        console.log(val);
        if(this.triggerChange){
          this.$emit('change', val);
        }else{
          this.$emit('input', val);
        }
      },
    }
  }
</script>

<style scoped>
</style>